module.exports = __webpack_public_path__ + "img/laboratory.eb239ba3.svg";